import { OptionalTimeZone } from '../../timezones'
import {
  ExtendedTemplateItemOptions,
  FilenameTemplateItem,
} from './FilenameTemplateItem'

type ConstructionAdminSubmittal = {
  packageNumber: string
  packageName: string
  createdDate: Date
  dispositionDate: Date | null
}
export class CASFilenameTemplateItem<
  Property extends keyof ConstructionAdminSubmittal,
  ID extends Lowercase<string>
> extends FilenameTemplateItem<
  ConstructionAdminSubmittal,
  'ConstructionAdminSubmittal',
  Property,
  ID
> {
  value<T extends ConstructionAdminSubmittal>(
    record: T | undefined | null,
    tz: OptionalTimeZone
  ): string {
    if (this.property === 'dispositionDate')
      return this.resolveDate(record?.dispositionDate, tz)
    else if (this.property === 'createdDate')
      return this.resolveDate(record?.createdDate, tz)
    return this.resolve(record?.[this.property])
  }

  /**
   * @see {@link FilenameTemplateItem}
   */
  constructor(
    options: ExtendedTemplateItemOptions<
      ConstructionAdminSubmittal,
      Property,
      ID
    >
  ) {
    super({ classType: 'ConstructionAdminSubmittal', ...options })
  }
}

type CASType = {
  name: string
}
export class CASTypeFilenameTemplateItem<
  Property extends keyof CASType,
  ID extends Lowercase<string>
> extends FilenameTemplateItem<CASType, 'CASType', Property, ID> {
  /**
   * @see {@link FilenameTemplateItem}
   */
  constructor(options: ExtendedTemplateItemOptions<CASType, Property, ID>) {
    super({ classType: 'CASType', ...options })
  }
}

type CASSubtype = {
  name: string
}
export class CASSubtypeFilenameTemplateItem<
  Property extends keyof CASSubtype,
  ID extends Lowercase<string>
> extends FilenameTemplateItem<CASSubtype, 'CASSubtype', Property, ID> {
  /**
   * @see {@link FilenameTemplateItem}
   */
  constructor(options: ExtendedTemplateItemOptions<CASSubtype, Property, ID>) {
    super({ classType: 'CASSubtype', ...options })
  }
}
